import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';


@Component({
    'selector': 'ciee-controlValidationSummary',
    'templateUrl': './control-validation-summary.component.html',
    standalone: false
})
export class ControlValidationSummaryComponent {
  @Input() control: AbstractControl;
  @Input() requiredMessage: String = '';
}
